import * as React from "react";
import * as ReactDOM from "react-dom";
import {connect} from "react-redux";
import {IScreenComponentProps, screenComponent} from "../screenComponent";
import {setScreen, showMainMenu} from "../../../store/actions/screens";
import {SlideShow} from "../../common/slideshow/SlideShow";
import {showGameIntro, startGame} from '../../../store/actions/game';

interface Props extends IScreenComponentProps
{
    showMainMenu: () => void;
    showGameIntro: () => void;
}

import './HowToPlay.scss';

class HowToPlay extends React.Component<Props, null>
{
    constructor(public props: Props)
    {
        super(props);
    }



    /**
     * render the component
     * @returns {JSX.Element}
     */
    render() : JSX.Element
    {
        const {showMainMenu, showGameIntro} = this.props;

        if (! this.props.active) return null;

        return <SlideShow
                    onCancel={showMainMenu}
                    onComplete={showGameIntro}>

            <div styleName={'slide'}>slide one</div>
            <div styleName={'slide'}>slide two</div>
            <div styleName={'slide'}>slide three</div>
            <div styleName={'slide'}>slide four</div>

        </SlideShow>
    }
}


/**
 * map the state to props
 * @param state
 */
const mapStateToProps = state =>
{
    return {
    }
};


/**
 * map dispatch functions to the component props
 * @param dispatch
 * @returns {{onModeSelect: ((mode: string) => any); onCountrySelect: ((country: string) => any)}}
 */
const mapDispatchToProps = dispatch =>
{
    return {
        showGameIntro: () => dispatch(showGameIntro()),
        showMainMenu: () => dispatch(showMainMenu()),
    }
};

export default screenComponent()(connect(mapStateToProps, mapDispatchToProps)(HowToPlay));



// WEBPACK FOOTER //
// ./src/ts/app/screens/how-to-play/HowToPlay.tsx